import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Radio, Box, Typography, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { ICarrinhoItem, TPromocoes } from '..';
import { IImgens } from '../../../../../../../types/api/ged/imgens';
import { QuantityInput } from '../../../../../../../components/BaseInputs/QuantityInput';
import { enqueueSnackbar } from 'notistack';

export default function DialogAddProduto({
    open,
    onClose,
    selectedProduct,
    onAddItem
}: AdicionarProdutoDialogProps) {

    const [selectedLoja, setSelectedLoja] = useState<TLojaComercial | null>(() => {
        const primeiroEstoque = selectedProduct.estoque[0];
        if (primeiroEstoque && primeiroEstoque.lojas.length > 0) {
            const lojasOrdenadas = primeiroEstoque.lojas
                .sort((a, b) => (b.estoque > 0 ? 1 : -1) - (a.estoque > 0 ? 1 : -1));
            return lojasOrdenadas[0];
        }
        return null;
    });

    const [quantidade, setQuantidade] = useState<string>('');
    const [produtoSelecionado, setProdutoSelecionado] = useState<TEstoqueItemComercial | null>(selectedProduct.estoque[0]);

    const handleClose = () => {
        setSelectedLoja(null);
        setQuantidade('');
        onClose();
    };

    const handleAdd = () => {

        if (selectedProduct && quantidade && selectedLoja && produtoSelecionado) {

            if (parseInt(quantidade) % selectedProduct.quantidade_embalagem !== 0) {
                enqueueSnackbar(`A quantidade (${quantidade}) deve ser múltipla da quantidade da embalagem (${selectedProduct.quantidade_embalagem}).`, { variant: 'error' });
                return;
            }

            const lojaSelecionada = selectedProduct.estoque
                .flatMap(item => item.lojas)
                .find(loja => loja.id === selectedLoja.id);

            onAddItem({
                id: produtoSelecionado.id.toString(),
                nome: produtoSelecionado.nome,
                imagem: selectedProduct.imagem,
                quantidade: parseInt(quantidade),
                preco: selectedLoja.preco,
                emite_receita: produtoSelecionado.emite_receita,
                agrotoxico_id: produtoSelecionado.agrotoxico_id,
                desconto: 0,
                tipoDesconto: "R$",
                setor: produtoSelecionado.setor,
                loja: {
                    promocao: selectedLoja.promocao,
                    id: selectedLoja.id,
                    nome: lojaSelecionada?.nome || '',
                    estoque: lojaSelecionada?.estoque || 0,
                    parametros: lojaSelecionada?.parametros || {
                        bloquear_nova_compra: 0,
                        aceita_decimal: 0,
                        exige_lote_para_pedido: 0,
                        permite_desconto: 0,
                        percentual_desconto_maximo: 0,
                        usa_codigo_barra: 0
                    }
                }
            });
        }
        handleClose();
    };

    const handleLojaSelect = (loja: TLojaComercial) => {
        if (loja.id !== selectedLoja?.id) {
            setSelectedLoja(loja);
            setQuantidade('');
        }
    };

     useEffect(() => {
        if (open) {
            const primeiroEstoque = selectedProduct.estoque[0];
            if (primeiroEstoque && primeiroEstoque.lojas.length > 0) {
                const lojasOrdenadas = primeiroEstoque.lojas
                    .sort((a, b) => (b.estoque > 0 ? 1 : -1) - (a.estoque > 0 ? 1 : -1));
                setSelectedLoja(lojasOrdenadas[0]);
                setProdutoSelecionado(primeiroEstoque);
                setQuantidade('');
            }
            
            // Buscar o primeiro radio button na DOM
            setTimeout(() => {
                const firstRadio = document.querySelector('input[type="radio"]:not([disabled])') as HTMLInputElement;
                if (firstRadio) {
                    firstRadio.focus();
                }
            }, 300);
        }
    }, [open, selectedProduct]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            scroll="body"
        >
            <DialogTitle variant='h5'>
                Selecione o produto do estoque
            </DialogTitle>
            <DialogContent>
                {selectedProduct.estoque.map((estoqueItem) => (
                    <Box key={estoqueItem.id} sx={{ mb: 4 }}>
                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid size={{xs: 12, md: 4}}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Nome no estoque
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {estoqueItem.id} - {estoqueItem.nome}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, md: 2}}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Departamento
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {estoqueItem.departamento.nome}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, md: 2}}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    Setor
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {estoqueItem.setor.nome}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, md: 2}}>
                                <Typography variant="subtitle2" color="textSecondary" align='right'>
                                    Unidade medida
                                </Typography>
                                <Typography align='right' variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {selectedProduct.unidade_medida}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, md: 2}}>
                                <Typography variant="subtitle2" color="textSecondary" align='right'>
                                    Qtd. Embalagem
                                </Typography>
                                <Typography align='right' variant="body1" sx={{ fontWeight: 'bold' }}>
                                    {selectedProduct.quantidade_embalagem}
                                </Typography>
                            </Grid>
                        </Grid>

                        <TableContainer sx={{ maxHeight: 300 }}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox"></TableCell>
                                        <TableCell>Loja</TableCell>
                                        <TableCell align="right">Estoque atual</TableCell>
                                        <TableCell align="center">{selectedProduct.quantidade_embalagem > 1 ? "Qtd. embalagem" : "Quantidade"}</TableCell>
                                        <TableCell align="right">Preço</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {estoqueItem.lojas
                                        .sort((a, b) => (b.estoque > 0 ? 1 : -1) - (a.estoque > 0 ? 1 : -1))
                                        .map((loja) => {
                                            const lojaSelected = (selectedLoja?.id === loja.id && produtoSelecionado?.id === estoqueItem.id);
                                            const semEstoque = loja.estoque <= 0;

                                            return (
                                                <TableRow
                                                    key={loja.id}
                                                    sx={{
                                                        cursor: semEstoque ? 'not-allowed' : 'pointer',
                                                        opacity: semEstoque ? 0.6 : 1
                                                    }}
                                                    onClick={() => {
                                                        !semEstoque && handleLojaSelect(loja);
                                                        !semEstoque && setProdutoSelecionado(estoqueItem);
                                                    }}
                                                >
                                                    <TableCell padding="checkbox">
                                                        <Radio
                                                            checked={lojaSelected}
                                                            disabled={semEstoque}
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    color: '#2E7D32'
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{loja.nome}</TableCell>
                                                    <TableCell align="right">{loja.estoque}</TableCell>
                                                    <TableCell align="center">
                                                        {lojaSelected ? (
                                                            <QuantityInput
                                                                value={quantidade}
                                                                min={selectedProduct.quantidade_embalagem}
                                                                onChange={setQuantidade}
                                                                disabled={!lojaSelected}
                                                                onClickCapture={(e) => e.stopPropagation()}
                                                                error={parseInt(quantidade) > loja.estoque}
                                                                increment={selectedProduct.quantidade_embalagem}
                                                            />
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        {new Intl.NumberFormat('pt-BR', {
                                                            style: 'currency',
                                                            currency: 'BRL'
                                                        }).format(loja.preco)}
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="inherit">
                    Cancelar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleAdd}
                    disabled={!selectedLoja || parseInt(quantidade) > selectedLoja.estoque}
                >
                    Adicionar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface AdicionarProdutoDialogProps {
    open: boolean;
    onClose: () => void;
    selectedProduct: TSelectedProduct
    onAddItem: (item: ICarrinhoItem) => void;
}

export type TSelectedProduct = {
    id: number;
    nome: string;
    quantidade_embalagem: number;
    unidade_medida: string;
    menor_preco: number;
    estoque_total: number;
    imagem: IImgens | null
    estoque: Array<TEstoqueItemComercial>;
}

export type TLojaComercial = {
    promocao?: TPromocoes | null;
    id: number;
    nome: string;
    estoque: number;
    preco: number;
    parametros: TParametrosProduto;
}

export type TEstoqueItemComercial = {
    id: string;
    nome: string;
    emite_receita: string;
    agrotoxico_id: number | null;
    departamento: {
        id: number;
        nome: string;
    };
    setor: {
        id: number;
        nome: string;
        permite_desconto: string;
        desconto: number;
        percentual_desconto_maximo: number;
        maximo_parcelas: number;
    };
    lojas: Array<TLojaComercial>;
}

export type TParametrosProduto = {
    bloquear_nova_compra: 0 | 1;
    aceita_decimal: 0 | 1;
    exige_lote_para_pedido: 0 | 1;
    permite_desconto: 0 | 1;
    percentual_desconto_maximo: number;
    usa_codigo_barra: 0 | 1;
}